import axios from "axios";
import Cookies from "js-cookie";
import { AUTH_TOKENS } from "../config";

/**
 * setting the token in headers of requests
 * @param {*} token
 * @returns {void}
 */
export default function setAuthorizationToken(token) {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
}

/**
 * Sends auth token to an iframe using postMessage
 * @param {HTMLIFrameElement} iframe - The iframe element to send the token to
 * @param {string} targetOrigin - The target origin for the postMessage
 * @author {Prachi Jain}
 */
export const sendAuthTokenToIframe = () => {
  const token = Cookies.get(AUTH_TOKENS.JWT_TOKEN);
  return token;
};
